<!--
 * @Descripttion:
 * @version: 2.0.0.0
 * @Author: ysanyu
 * @Date: 2020-08-22 16:12:39
 * @LastEditors: ysanyu
 * @LastEditTime: 2020-10-11 21:51:37
-->

<template>
  <div id="app">
    <common-header v-if="!whiteNames.includes($route.name)" />
    <div :class="!whiteNames.includes($route.name) ? 'main-body' : ''">
      <router-view />
    </div>
  </div>
</template>

<script>
import commonHeader from '@/components/commonHeader'
export default {
  name: 'App',
  components: {
    commonHeader
  },
  data() {
    return {
      whiteNames: ['Home', 'Me']
    }
  }
}
</script>

<style>
  /*#app{*/
    /*touch-action:none;*/
  /*}*/
#__vconsole {
  z-index: 999;
}

.main-body {
  padding-top: 80px;
}
</style>
